import angular from "angular";
import {popup} from "@acng/frontend-discovery";
import {portal} from '../../core/portal.js';

angular.module('userPool')
  .run(['$rootScope', 'userPoolApi', '$translate', '$location', function ($rootScope, userPoolApi, $translate, $location) {

    var matches = /\/user\/reactivate\/(.+)/.exec($location.path());

    if (!matches) {
      return;
    }

    userPoolApi.reactivate(matches[1]).then(function (res) {
      $rootScope.$broadcast('userPool.login.success', res.data);
      $translate('userPool.accountReactivatedLong', { 'nickname': res.data.nickname, 'portal': portal }).then(function (text) {
        popup().info(text);
        $location.url('/');
      });
    });

  }]);
